// extracted by mini-css-extract-plugin
export default {"listItem":"ItemsList_listItem__t-c3J"};